var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "card-header pl-0" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("div", { staticClass: "dropdown mr-3 d-none" }),
            _vm._v(" "),
            _c("span", { staticClass: "ml-3" }, [
              _c("img", {
                staticClass: "heading-icon mr-2",
                attrs: { src: require("@/assets/device_hub_icon.svg") }
              }),
              _vm._v("\n        Inspector")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-primary ml-3" })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "inspector-wrapper" })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7537fe5e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537fe5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/placeholderinspector.vue
// module id = null
// module chunks = 